/* globals jQuery */
/*
*	jquery.liftoff.js
*              ___		\/)'/
*        _____|| ||_____ (o//\    *BEEP BOOP*
*        | o  |___|  o |\o)/
*        |   [(===)]   |)
*        |_____| |_____|
*   ___  ____//\_/\\____  ___
*  |   | |_|___\_/___|_| |   |
* [|   |]| |===      | |[|   |]
*  |___| |_|o_______o|_| |___|
*   \ |    \|_______|/    | /
*  _|_|_    [__|_|__]    _|_|_
*  |___|      |___|      |___|
*  |   |       | |       |   |
*             [| |]
*/

/**
*	jQuery plugin that streamlines the creation of an element that "travels" a set px distance in the document as the user scrolls
*	@version 0.1.1
*	@author Scott Park, Aric Ng
*
*	Changelog
*	0.1.1
*	- Formatting updates
*	- Moved event binding to happen on first liftoff call
*/

/**
* jQuery
* @external "jQuery"
* @see {@link http://jquery.com/ | jQuery}
*/

/**
* The jQuery plugin namespace
* @external "jQuery.fn"
* @see {@link http://learn.jquery.com/plugins/|jQuery Plugins}
*/
(function($) {

	/**
	* @function external:"jQuery.fn".liftoff
	* @description Preps liftoff for the target element by wrapping it in a div of class .liftoff_wrapper.
	* The .liftoff_wrapper provides the 'track' in which the element travels until it completes its travel distance, usually the top of the next element.
	* @param scroll_travel {Number} Distance in px to travel
	* @param options {Object}
	* 	@param {Number} [options.offset=0] Sets the offset of the liftoff in px. 100 will have liftoff start at 100 from the target element
	* 	@param {boolean} [options.needs_wrapper_parent=true]  Sets to use wrapper for positioning and sizing, if false, it uses the parent element otherwise
	* 	@param {boolean} [options.debug = false] Shows debug messages specific to the target element if true
	* @returns {jQuery} The target element as a jQuery selector
	*/
	jQuery.fn.liftoff = function(scroll_travel, options) {
		var $ = jQuery;
		var $this = $(this);
		var $wrapper;
		var liftoff_data;
		var defaults = {
			offset: 0,
			needs_wrapper_parent: true,
			debug: false
		};
		var rect;
		var width;
		var height;

		options = $.extend(defaults, options);

		// Bind liftoff related events if this is the first time running liftoff
		if (jQuery.fn.liftoff.init === false) {

			jQuery.fn.liftoff.init = true;
			(function() {
				var $window = $(window);

				$('body').append('<style>\n.liftoff { position: absolute; }\n.liftoff_finished { position: absolute !important; bottom: 0 !important; top: auto !important; }\n</style>');

				$window.on('scroll liftoff_scroll', function() {
					$('.liftoff_wrapper').each(function() {
						var $this = $(this);
						var $target = $this.find('.liftoff');
						
						if ($target.hasClass('liftoff_disabled')) {
							return;
						}
						
						$target.liftoffUpdate();
					});
				})
				.on('resize liftoff_resize', function() {

					$('.liftoff_wrapper').each(function() {
						var $this = $(this);
						var $target = $this.find('.liftoff');
						var rect;
						var left;
						var width;
						var height;
						
						if ($target.hasClass('liftoff_disabled')) {
							return;
						}
						
						// "Rest" the liftoff target for natural sizing
						if ($target.hasClass('liftoff_in_progress')) {
							$target.css({position: '', width: '', height: '', left: ''});
							/*
								Get the floating point widths/heights of the element
								jQuery's width()/height() functions seem to only returned rounded values
							*/
							rect = $target[0].getBoundingClientRect();
							width = rect.right-rect.left;
							height = rect.bottom-rect.top;

							left = $target.offset().left;
							$target.css({position: 'fixed', width: width, height: height, left: left});
						}
					});
				});
			})();
		}

		if (options.debug) {
			console.log($this.attr('id'), $this.attr('class'), 'liftoff: Creating');
		}

		// Must have a scroll_travel, and must be greater than 0
		if (scroll_travel === undefined || scroll_travel <= 0) {
			if (options.debug) {
				console.log($this.attr('id'), $this.attr('class'), 'liftoff: Failed');
			}
			return;
		}

		// Wrap this element in a wrapper that'll act as the 'track'
		$wrapper = $this.wrap('<div class="liftoff_wrapper"></div>').parent();
		if (options.needs_wrapper_parent) {
			$wrapper.css({position: 'relative'});
		}

		rect = $this[0].getBoundingClientRect();
		width = rect.right-rect.left;
		height= rect.bottom-rect.top;

		// Prop open wrapper so that element has a 'track' to travel
		$wrapper.css({height: scroll_travel+height});

		// Mark as a element managed by liftoff
		$this.addClass('liftoff');

		liftoff_data = {
			offset: options.offset,
			travel: scroll_travel,
			progress: 0,
			$wrapper: $wrapper,
			debug: options.debug
		};

		$this.data('liftoff', liftoff_data);

		$this.liftoffUpdate();

		if (options.debug) {
			console.log($this.attr('id'), $this.attr('class'), 'liftoff: Created');
		}
		
		return $this;
	};
	jQuery.fn.liftoff.init = false;

	/**
	* @function external:"jQuery.fn".liftoffSetTravel
	* @description Sets the liftoff travel of the target element
	* @param new_travel {Number} px value to set for the new travel distance, must be a positive value
	* @returns {jQuery} The target element as a jQuery selector
	*/
	jQuery.fn.liftoffSetTravel = function(new_travel) {
		var $ = jQuery;
		var $this = $(this);
		var data = $this.data('liftoff');
		var old_travel;

		if (!$this.hasClass('liftoff') || data === undefined || new_travel > 0) {
			return $this;
		}

		old_travel = data.travel;
		data.travel = new_travel;

		$this.liftoffUpdate();

		if (data.debug == true) {
			console.log($this.attr('id'), $this.attr('class'), 'liftoff: liftoff travel set from', old_travel, 'to', data.travel);
		}
		
		return $this;
	};

	/**
	* @function external:"jQuery.fn".liftoffOffset
	* @description Sets the liftoff offset of the target element
	* @param new_offset {Number} px value to set for new offset, this can be a negative value
	* @returns {jQuery} The target element as a jQuery selector
	*/
	jQuery.fn.liftoffSetOffset = function(new_offset) {
		var $ = jQuery;
		var $this = $(this);
		var data = $this.data('liftoff');
		var old_offset;

		if (!$this.hasClass('liftoff') || data === undefined) {
			return $this;
		}

		old_offset = data.offset;
		data.offset = new_offset;

		$this.liftoffUpdate();

		if (data.debug == true) {
			console.log($this.attr('id'), $this.attr('class'), 'liftoff: liftoff offset set from', old_offset, 'to', data.offset);
		}
		
		return $this;
	};

	/**
	* @function external:"jQuery.fn".liftoffProgress
	* @description Returns the current liftoff progress of target element
	* This value comes from jQuery.fn.liftoffUpdate
	* @returns {float} Float value from 0 to 1 that represents the target element's
	* current liftoff progress or -1 if the target element isn't a liftoff handled element
	*/
	jQuery.fn.liftoffProgress = function() {
		var $ = jQuery;
		var $this = $(this);
		var data = $this.data('liftoff');

		if (!$this.hasClass('liftoff') || data === undefined) {
			return -1;
		}

		return data.progress;
	};

	/**
	* @function external:"jQuery.fn".liftoffUpdate
	* @description Updates the liftoff progress of the target element. Ensures that the target element touches the 'next'
	* element by adjusting the target's wrapper height as:
	* 	Travel distance (in px) + Target element height
	* At start the element begins at the top of the wrapper, once the scroll position is within range, the element becomes
	* fixed plus offset, and once the element reaches it's specified travel distance, the element uses bottom: 0
	* to stay at the bottom of its wrapper
	* @returns {jQuery} The target element as a jQuery selector
	*/
	jQuery.fn.liftoffUpdate = function() {
		var $ = jQuery;
		var $this = $(this);
		var data = $this.data('liftoff');
		var $wrapper;
		var scroll_position = $(window).scrollTop();
		var rect;
		var width;
		var height;

		if (!$this.is(':visible') || !$this.hasClass('liftoff') || data === undefined || $this.hasClass('liftoff_disabled')) {
			return $this;
		}

		rect = $this[0].getBoundingClientRect();
		width = rect.right-rect.left;
		height= rect.bottom-rect.top;

		$wrapper = data.$wrapper;
		$wrapper.css({height: data.travel+height});

		// Removes the finished class if the user scrolls above the liftoff target
		if ($this.hasClass('liftoff_finished') && scroll_position < $this.offset().top-data.offset) {
			$this.removeClass('liftoff_finished');
		}

		// Liftoff in range
		if (scroll_position >= $wrapper.offset().top-data.offset && data.travel-($this.offset().top-$wrapper.offset().top) > 0 && !$this.hasClass('liftoff_finished'))
		{
			$this.addClass('liftoff_in_progress');

			if (data.debug) {
				console.log($this.attr('id'), $this.attr('class'), 'liftoff: liftoff in range');
			}

			$this.css({top: data.offset, position: 'fixed', height: height, width: width, left: $this.offset().left});
		}

		// Liftoff before range
		else if (scroll_position < $wrapper.offset().top - data.offset) {
			if (data.debug) {
				console.log($this.attr('id'), $this.attr('class'), 'liftoff: liftoff before range');
			}

			$this.removeClass('liftoff_finished liftoff_in_progress');
			$this.css({top: '', position: '', width: '', height: '', left: ''});
		}

		// Liftoff after range
		if (data.travel-($(window).scrollTop()+data.offset-$wrapper.offset().top) <= 0 && !$this.hasClass('liftoff_finished')) {
			if (data.debug) {
				console.log($this.attr('id'), $this.attr('class'), 'liftoff: liftoff after range');
			}

			$this.addClass('liftoff_finished').removeClass('liftoff_in_progress');
			$this.css({top: '', left: '', position: '', width: '', height: ''});
		}

		// Track progress
		data.progress = ($(window).scrollTop()+data.offset-$wrapper.offset().top)/data.travel; //(($this.offset().top-$wrapper.offset().top))/data.travel;
		data.progress = data.progress > 1 ? 1 : (data.progress < 0 ? 0 : data.progress);

		$this.trigger('liftoff_update', [data.progress]);
		return $this;
	};
	
	jQuery.fn.liftoffDisable = function() {
		var $ = jQuery;
		var $this = $(this);
	
		$this.addClass('liftoff_disabled');
	};

	jQuery.fn.liftoffEnable = function() {
		var $ = jQuery;
		var $this = $(this);
	
		$this.removeClass('liftoff_disabled');
	};
	
})(jQuery);